const queue = [];
let current;

export function initInterstitials() {
    const container = $('.interstitials');
    const items = container.find('.interstitial');
    if (!items.length) {
        return;
    }

    items.each(function () {
        const id = $(this).data('id');
        const storage = localStorage.getItem(`interstitial-${id}-closed`);

        if (!storage) {
            queue.push($(this));
        }
    });

    if (!queue.length) {
        return;
    }

    showNext();

    container.addClass('interstitials-open');

    $('.interstitials-close button, .interstitials-backdrop').click(function () {
        const currentId = current.data('id');
        localStorage.setItem(`interstitial-${currentId}-closed`, '1');

        if (queue.length) {
            showNext();
            return;
        }

        container.removeClass('interstitials-open');
    });
}

function showNext() {
    current?.removeClass('active');
    const element = current = queue.pop();
    element.addClass('active');
}